import { render } from "./HomeStorageItem.vue?vue&type=template&id=04abd5ba&scoped=true&ts=true"
import script from "./HomeStorageItem.vue?vue&type=script&lang=ts"
export * from "./HomeStorageItem.vue?vue&type=script&lang=ts"

import "./HomeStorageItem.vue?vue&type=style&index=0&id=04abd5ba&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04abd5ba"]])

export default __exports__